import { HandleApiError } from "sr/helpers/functions/HandleApiError";
import ApiResponse from "sr/models/ApiResponse";
import { get } from "sr/utils/axios";

export const getAppSettings = async () => {
  try {
    return await get<ApiResponse<[]>>(`/app-settings/public`).then((res) => {
      if (res?.success === true) {
        return res;
      } else {
        return null;
      }
    });
  } catch (e) {
    HandleApiError(e);
  }
};
